<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <erklaerung-medical-contact />
        <ion-row class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/talking_teeth.svg') +
                  ')',
              }"
              @click="openAnleitungMedicalContact()"
            >
              <div class="c-nugget__label">
                So einfach geht's
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/browser-anfrage.svg') +
                  ')',
              }"
              @click="openFormCoaching"
            >
              <div class="c-nugget__label">
                Teilnahemerklärung anfordern
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  IonBackButton,
  modalController,
} from "@ionic/vue";
import ErklaerungMedicalContact from "@/components/ErklaerungMedicalContact";
import FormCoaching from "@/components/FormCoaching";
import AnleitungMedicalContact from "@/views/AnleitungMedicalContact";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    ErklaerungMedicalContact,
    IonBackButton,
  },
  data() {
    return {};
  },
  methods: {
    async openFormCoaching() {
      const modal = await modalController.create({
        component: FormCoaching,
      });
      return modal.present();
    },
    async openAnleitungMedicalContact() {
      const modal = await modalController.create({
        component: AnleitungMedicalContact,
        componentProps: {
          from: this.from,
        },
      });
      return modal.present();
    },
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
